<h2 mat-dialog-title>{{ 'FOLDER_ADD_TO_FOLDER' | transloco }}</h2>
<mat-dialog-content>
  @if (folders.length === 0) {
    <p class="no-folders">{{ 'FOLDER_NONE_YET' | transloco }}</p>
  } @else {
    <div class="folder-list">
      @for (folder of folders; track folder.id) {
        <label class="folder-option">
          <mat-checkbox [checked]="isSelected(folder)" (change)="toggle(folder)"></mat-checkbox>
          <mat-icon>folder</mat-icon>
          <span>{{ folder.name }}</span>
        </label>
      }
    </div>
  }
  <button mat-stroked-button class="create-btn" (click)="createFolder()">
    <mat-icon>create_new_folder</mat-icon>
    {{ 'FOLDER_NEW' | transloco }}
  </button>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="null">{{ 'CANCEL' | transloco }}</button>
  <button mat-flat-button color="primary" (click)="confirm()">
    {{ 'SAVE' | transloco }}
  </button>
</mat-dialog-actions>
